export default function MobileMenu() {
	const mobileMenuToggles = document.querySelectorAll('.js-menu-toggle');

	$ = jQuery;

	if (!mobileMenuToggles) {
		return;
	}

	mobileMenuToggles.forEach((toggle) => {
		toggle.addEventListener('click', () => {
			const body = document.querySelector('body');

			// Close search dialog if it is open
			const searchModal = document.querySelector('#dialog-search');
			if (searchModal) {
				searchModal.classList.remove('is-open');
			}
			body.classList.remove('search-open');

			//toggle.classList.toggle('menu-toggle--active');
			body.classList.toggle('menu-open');
		});
	});

	// Find all items with class menu-item-has-children in .menu--responsive-menu and use slideToggle to toggle the sub-menu
	const menuItems = document.querySelectorAll('.menu--responsive-menu .menu-item-has-children');
	menuItems.forEach((item) => {
		item.addEventListener('click', () => {
			$(item).find('.sub-menu').slideToggle();
			$(item).find('> a').toggleClass('menu-item-active');
		});
	});
}
